export default __webpack_public_path__ + "static/media/land-2.3b9f53e8.png";